"use client";

import React from "react";
import { FileText } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface QuoteBannerCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, QuoteBannerCopy> = {
  en: {
    eyebrow: "Filter Mesh Specifications",
    heading: "Ready to Specify Your Industrial Filter Mesh?",
    lead: "Send your target aperture, alloy grade, and roll or component dimensions. Our engineers review specifications and return verified pricing for your filtration system.",
    secondaryLabel: "Product Selection Guide",
    note: "Manufactured strictly to ISO 9044 and ASTM E2016 dimensional tolerances"
  },
  zh: {
    eyebrow: "过滤丝网技术规格",
    heading: "准备好确认您的工业过滤丝网规格了吗？",
    lead: "发送您的目标孔径、合金牌号以及卷材或定制组件尺寸。我们的工程师将核实技术规范并提供针对性报价。",
    secondaryLabel: "查看选型指南",
    note: "制造严格符合 ISO 9044 与 ASTM E2016 尺寸公差标准"
  },
  es: {
    eyebrow: "Especificaciones de malla de filtración",
    heading: "¿Listo para definir su malla de filtración industrial?",
    lead: "Envíe su apertura objetivo, aleación y dimensiones de rollo o componentes. Nuestros ingenieros revisan las especificaciones y cotizan según sus necesidades.",
    secondaryLabel: "Guía de selección",
    note: "Fabricación rigurosamente ajustada a las tolerancias dimensionales ISO 9044 y ASTM E2016"
  },
  de: {
    eyebrow: "Filtergewebe-Spezifikationen",
    heading: "Bereit, Ihr industrielles Filtergewebe zu spezifizieren?",
    lead: "Senden Sie uns Maschenweite, Legierung sowie Rollen- oder Bauteilabmessungen. Unsere Ingenieure prüfen die Spezifikationen und erstellen ein verifiziertes Angebot.",
    secondaryLabel: "Produktauswahlleitfaden",
    note: "Gefertigt nach den Maßtoleranzen der Normen ISO 9044 und ASTM E2016"
  },
  fr: {
    eyebrow: "Spécifications des toiles de filtration",
    heading: "Prêt à définir votre toile de filtration industrielle ?",
    lead: "Transmettez votre ouverture cible, nuance d'alliage et dimensions de rouleau ou pièces. Nos ingénieurs examinent vos spécifications et établissent une offre vérifiée.",
    secondaryLabel: "Guide de sélection",
    note: "Fabrication strictement conforme aux tolérances dimensionnelles ISO 9044 et ASTM E2016"
  },
  pt: {
    eyebrow: "Especificações de malha de filtração",
    heading: "Pronto para definir sua malha de filtração industrial?",
    lead: "Envie sua abertura desejada, liga metálica e dimensões de rolo ou componentes. Nossos engenheiros analisam as especificações e preparam uma proposta verificada.",
    secondaryLabel: "Guía de seleção",
    note: "Fabricação rigorosamente alinhada às tolerâncias dimensionais ISO 9044 e ASTM E2016"
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotectabanner" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ProductSelectionPage",
    icon: FileText
  }} note={content.note} />;
}